import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Spinner from '../../components/Spinner';

export default function ListaImpreseSOA() {
  const [imprese, setImprese] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtro, setFiltro] = useState('');
  const [filtroCat, setFiltroCat] = useState('');
  const [filtroClass, setFiltroClass] = useState('');
  const [form, setForm] = useState({ ragione_sociale: '', citta: '' });
  const [mostraForm, setMostraForm] = useState(false);
  const [saving, setSaving] = useState(false);
  const [selezionati, setSelezionati] = useState(new Set());
  const [eliminando, setEliminando] = useState(false);
  const [pagina, setPagina] = useState(1);
  const PER_PAGINA = 15;
  const navigate = useNavigate();

  function carica() {
    axios.get('/api/imprese-soa')
      .then(r => setImprese(r.data))
      .finally(() => setLoading(false));
  }

  useEffect(() => { carica(); }, []);

  async function handleImportLavori(e) {
    const file = e.target.files[0];
    if (!file) return;
    if (!window.confirm('Importare i lavori? Per ogni ditta trovata nel file, i lavori esistenti verranno sostituiti.')) {
      e.target.value = ''; return;
    }
    try {
      const fd = new FormData();
      fd.append('file', file);
      const r = await axios.post('/api/imprese-soa/importa-lavori', fd);
      const msg = `Importati: ${r.data.importati} lavori.` +
        (r.data.errori?.length ? `\nNon trovate: ${r.data.errori.slice(0, 5).join(', ')}` : '');
      alert(msg);
      carica();
    } catch (err) {
      alert('Errore: ' + (err.response?.data?.error || err.message));
    } finally {
      e.target.value = '';
    }
  }

  async function importaDaAnagrafica() {
    if (!window.confirm('Importare tutte le ditte da "Iscrizione 1"? Le ditte già presenti verranno saltate.')) return;
    try {
      const r = await axios.post('/api/imprese-soa/importa-da-anagrafica');
      alert(`Importate: ${r.data.inserite} ditte. Saltate (già presenti): ${r.data.saltate}.`);
      carica();
    } catch (err) {
      alert('Errore: ' + (err.response?.data?.error || err.message));
    }
  }

  async function crea(e) {
    e.preventDefault();
    setSaving(true);
    try {
      const r = await axios.post('/api/imprese-soa', form);
      navigate(`/admin/imprese-soa/${r.data.id}`);
    } finally {
      setSaving(false);
    }
  }

  function toggleSelezionato(id) {
    setSelezionati(prev => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  }

  function toggleTutti() {
    const idsPagina = paginata.map(i => i.id);
    const tuttiSelezionati = idsPagina.every(id => selezionati.has(id));
    setSelezionati(prev => {
      const next = new Set(prev);
      tuttiSelezionati ? idsPagina.forEach(id => next.delete(id)) : idsPagina.forEach(id => next.add(id));
      return next;
    });
  }

  async function eliminaSelezionati() {
    if (!selezionati.size) return;
    if (!window.confirm(`Eliminare ${selezionati.size} ditta/ditte selezionate? Verranno eliminati anche tutti i lavori associati.`)) return;
    setEliminando(true);
    try {
      await axios.post('/api/imprese-soa/elimina-multipla', { ids: [...selezionati] });
      setSelezionati(new Set());
      carica();
    } catch (err) {
      alert('Errore: ' + (err.response?.data?.error || err.message));
    } finally {
      setEliminando(false);
    }
  }

  function badgeScadenza(att_data_scadenza) {
    if (!att_data_scadenza) return null;
    const giorni = Math.ceil((new Date(att_data_scadenza) - new Date()) / (1000 * 60 * 60 * 24));
    if (giorni < 0)    return <span className="ml-2 text-xs font-semibold px-2 py-0.5 rounded-full bg-red-100 text-red-700">Scaduta</span>;
    if (giorni <= 180) return <span className="ml-2 text-xs font-semibold px-2 py-0.5 rounded-full bg-yellow-100 text-yellow-700">Scade tra {giorni}gg</span>;
    return null;
  }

  const filtrate = imprese.filter(i => {
    const testoOk = i.ragione_sociale.toLowerCase().includes(filtro.toLowerCase()) ||
      (i.citta || '').toLowerCase().includes(filtro.toLowerCase());
    const cats = i.categorie_attestazione || [];
    const catOk = !filtroCat || cats.some(c => c.categoria === filtroCat);
    const classOk = !filtroClass || cats.some(c => c.classifica === filtroClass &&
      (!filtroCat || c.categoria === filtroCat));
    return testoOk && catOk && classOk;
  });
  const nPagine = Math.max(1, Math.ceil(filtrate.length / PER_PAGINA));
  const paginaCorretta = Math.min(pagina, nPagine);
  const paginata = filtrate.slice((paginaCorretta - 1) * PER_PAGINA, paginaCorretta * PER_PAGINA);

  return (
    <div>
      <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
        <h1 className="text-2xl font-bold text-[#1A3A5C]">Certificati SOA</h1>
        <div className="flex flex-wrap gap-2">
          <label className="cursor-pointer border border-[#1A3A5C] text-[#1A3A5C] px-4 py-2 rounded-lg text-sm font-medium hover:bg-[#EEF4FB] transition">
            Importa lavori Excel
            <input type="file" accept=".xlsx,.xls" className="hidden" onChange={handleImportLavori} />
          </label>
          <button
            onClick={importaDaAnagrafica}
            className="border border-[#1A3A5C] text-[#1A3A5C] px-4 py-2 rounded-lg text-sm font-medium hover:bg-[#EEF4FB] transition"
          >
            Importa da anagrafica
          </button>
          {selezionati.size > 0 && (
            <button
              onClick={eliminaSelezionati}
              disabled={eliminando}
              className="bg-red-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-red-700 transition disabled:opacity-50"
            >
              {eliminando ? 'Elimino...' : `Elimina selezionate (${selezionati.size})`}
            </button>
          )}
          <button
            onClick={() => setMostraForm(f => !f)}
            className="bg-[#1A3A5C] text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-[#2E6096] transition"
          >
            + Nuova ditta
          </button>
        </div>
      </div>

      {mostraForm && (
        <form onSubmit={crea} className="bg-white rounded-xl shadow p-5 mb-6 flex gap-4 items-end flex-wrap">
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">Ragione sociale</label>
            <input
              required
              value={form.ragione_sociale}
              onChange={e => setForm(f => ({ ...f, ragione_sociale: e.target.value }))}
              className="border border-gray-300 rounded-lg px-3 py-2 text-sm w-72 focus:outline-none focus:ring-2 focus:ring-[#2E6096]"
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">Città</label>
            <input
              value={form.citta}
              onChange={e => setForm(f => ({ ...f, citta: e.target.value }))}
              className="border border-gray-300 rounded-lg px-3 py-2 text-sm w-40 focus:outline-none focus:ring-2 focus:ring-[#2E6096]"
            />
          </div>
          <button
            type="submit"
            disabled={saving}
            className="bg-[#1A3A5C] text-white px-5 py-2 rounded-lg text-sm font-medium hover:bg-[#2E6096] transition disabled:opacity-50"
          >
            {saving ? 'Salvo...' : 'Crea'}
          </button>
          <button type="button" onClick={() => setMostraForm(false)} className="text-gray-400 text-sm hover:text-gray-600">
            Annulla
          </button>
        </form>
      )}

      <div className="flex flex-wrap gap-2 mb-4">
        <input
          type="text"
          placeholder="Cerca per ragione sociale o città..."
          value={filtro}
          onChange={e => { setFiltro(e.target.value); setPagina(1); }}
          className="flex-1 min-w-48 border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#2E6096]"
        />
        <select
          value={filtroCat}
          onChange={e => { setFiltroCat(e.target.value); setFiltroClass(''); setPagina(1); }}
          className="border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#2E6096]"
        >
          <option value="">Tutte le categorie</option>
          {[...new Set(imprese.flatMap(i => (i.categorie_attestazione || []).map(c => c.categoria)))].sort()
            .map(c => <option key={c} value={c}>{c}</option>)}
        </select>
        <select
          value={filtroClass}
          onChange={e => { setFiltroClass(e.target.value); setPagina(1); }}
          className="border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#2E6096]"
        >
          <option value="">Tutte le classifiche</option>
          {['I','II','III','III-bis','IV','IV-bis','V','VI','VII','VIII'].map(c => <option key={c} value={c}>{c}</option>)}
        </select>
        {(filtroCat || filtroClass) && (
          <button onClick={() => { setFiltroCat(''); setFiltroClass(''); setPagina(1); }}
            className="text-sm text-gray-500 hover:text-gray-800 px-2">✕ Reset filtri</button>
        )}
      </div>

      {!loading && (
        <p className="text-sm text-gray-500 mb-2">
          {filtrate.length} {filtrate.length === 1 ? 'ditta' : 'ditte'}
          {filtro && ` su ${imprese.length} totali`}
        </p>
      )}

      {loading ? <Spinner /> : (
        <div className="bg-white rounded-xl shadow overflow-hidden">
          {filtrate.length === 0 ? (
            <p className="text-center text-gray-500 py-12">Nessuna ditta trovata</p>
          ) : (<>
            {/* Card view — mobile */}
            <div className="sm:hidden divide-y divide-gray-100">
              {paginata.map(imp => (
                <div key={imp.id} className={`p-4 flex items-center gap-3 ${selezionati.has(imp.id) ? 'bg-red-50' : ''}`}>
                  <input type="checkbox" checked={selezionati.has(imp.id)} onChange={() => toggleSelezionato(imp.id)} className="cursor-pointer flex-shrink-0" />
                  <div className="flex-1 min-w-0" onClick={() => navigate(`/admin/imprese-soa/${imp.id}`)}>
                    <p className="font-semibold text-[#1A3A5C] truncate">{imp.ragione_sociale}{badgeScadenza(imp.att_data_scadenza)}</p>
                    <p className="text-sm text-gray-500">{imp.citta || '—'} · {imp._count?.lavori ?? 0} lavori</p>
                  </div>
                  <button onClick={() => navigate(`/admin/imprese-soa/${imp.id}`)} className="text-[#2E6096] text-sm font-medium flex-shrink-0">Apri →</button>
                </div>
              ))}
            </div>
            {/* Tabella — desktop */}
            <table className="hidden sm:table w-full text-sm">
              <thead className="bg-[#EEF4FB] text-[#1A3A5C] font-semibold">
                <tr>
                  <th className="px-4 py-3 w-10">
                    <input
                      type="checkbox"
                      checked={paginata.length > 0 && paginata.every(i => selezionati.has(i.id))}
                      onChange={toggleTutti}
                      className="cursor-pointer"
                    />
                  </th>
                  <th className="text-center px-4 py-3 w-12 text-gray-400">#</th>
                  <th className="text-left px-4 py-3">Ragione sociale</th>
                  <th className="text-left px-4 py-3">Città</th>
                  <th className="text-left px-4 py-3">Categorie attestate</th>
                  <th className="text-center px-4 py-3">N. lavori</th>
                  <th className="px-4 py-3"></th>
                </tr>
              </thead>
              <tbody>
                {paginata.map((imp, i) => (
                  <tr key={imp.id} className={selezionati.has(imp.id) ? 'bg-red-50' : i % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                    <td className="px-4 py-3">
                      <input type="checkbox" checked={selezionati.has(imp.id)} onChange={() => toggleSelezionato(imp.id)} className="cursor-pointer" />
                    </td>
                    <td className="px-4 py-3 text-center text-gray-400 text-xs">{(paginaCorretta - 1) * PER_PAGINA + i + 1}</td>
                    <td className="px-4 py-3 font-medium text-[#1A3A5C]">{imp.ragione_sociale}{badgeScadenza(imp.att_data_scadenza)}</td>
                    <td className="px-4 py-3 text-gray-600">{imp.citta || '—'}</td>
                    <td className="px-4 py-3">
                      <div className="flex flex-wrap gap-1">
                        {(imp.categorie_attestazione || []).slice(0, 4).map(c => (
                          <span key={c.id} className="text-xs bg-[#EEF4FB] text-[#1A3A5C] px-1.5 py-0.5 rounded font-medium">{c.categoria} {c.classifica}</span>
                        ))}
                        {(imp.categorie_attestazione || []).length > 4 && (
                          <span className="text-xs text-gray-400">+{imp.categorie_attestazione.length - 4}</span>
                        )}
                      </div>
                    </td>
                    <td className="px-4 py-3 text-center text-gray-500">{imp._count?.lavori ?? 0}</td>
                    <td className="px-4 py-3 text-right">
                      <button onClick={() => navigate(`/admin/imprese-soa/${imp.id}`)} className="text-[#2E6096] hover:underline font-medium">Apri →</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>)}
        </div>
      )}

      {!loading && nPagine > 1 && (
        <div className="flex items-center justify-center gap-2 mt-4">
          <button
            onClick={() => setPagina(1)}
            disabled={paginaCorretta === 1}
            className="px-3 py-1 rounded text-sm border border-gray-300 disabled:opacity-40 hover:bg-gray-100"
          >«</button>
          <button
            onClick={() => setPagina(p => Math.max(1, p - 1))}
            disabled={paginaCorretta === 1}
            className="px-3 py-1 rounded text-sm border border-gray-300 disabled:opacity-40 hover:bg-gray-100"
          >‹</button>
          {Array.from({ length: nPagine }, (_, i) => i + 1)
            .filter(p => p === 1 || p === nPagine || Math.abs(p - paginaCorretta) <= 2)
            .reduce((acc, p, idx, arr) => {
              if (idx > 0 && p - arr[idx - 1] > 1) acc.push('...');
              acc.push(p);
              return acc;
            }, [])
            .map((p, idx) => p === '...'
              ? <span key={`e${idx}`} className="px-2 text-gray-400">…</span>
              : <button
                  key={p}
                  onClick={() => setPagina(p)}
                  className={`px-3 py-1 rounded text-sm border ${p === paginaCorretta ? 'bg-[#1A3A5C] text-white border-[#1A3A5C]' : 'border-gray-300 hover:bg-gray-100'}`}
                >{p}</button>
            )
          }
          <button
            onClick={() => setPagina(p => Math.min(nPagine, p + 1))}
            disabled={paginaCorretta === nPagine}
            className="px-3 py-1 rounded text-sm border border-gray-300 disabled:opacity-40 hover:bg-gray-100"
          >›</button>
          <button
            onClick={() => setPagina(nPagine)}
            disabled={paginaCorretta === nPagine}
            className="px-3 py-1 rounded text-sm border border-gray-300 disabled:opacity-40 hover:bg-gray-100"
          >»</button>
        </div>
      )}
    </div>
  );
}
